// extracted by mini-css-extract-plugin
module.exports = {"btn-warning":"util_btn-warning__29Z6Z","ant-btn-primary":"util_ant-btn-primary__MwtCg","v-align-bottom":"util_v-align-bottom__2JoH4"};